import { put, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import { signOut } from '@/features/auth/store/auth.slice';
import * as sessionsApi from '../api/staff-sessions.api';
import {
  fetchStaffSessions,
  revokeAllStaffSessions,
  revokeStaffSession,
} from './staff-sessions.slice';

const apiSaga = createPanelApiSaga();

/**
 * Oturum sagaları. Tekil sonlandırma listeyi tazeler (`INVALIDATION_MAP`
 * `staffSessions/revoke`); toplu sonlandırma OTURUM SINIRIDIR — sunucu bu
 * cihazın oturumunu da düşürdüğü için `signOut.success` yayınlanır ve kapı
 * personeli giriş ekranına götürür (kök sıfırlama `root-reducer`da).
 */
export function* staffSessionsSaga() {
  yield takeLatest(
    fetchStaffSessions.request.type,
    apiSaga(fetchStaffSessions, sessionsApi.fetchStaffSessions),
  );

  yield takeLatest(
    revokeStaffSession.request.type,
    apiSaga(
      revokeStaffSession,
      async (arg) => {
        await sessionsApi.revokeStaffSession(arg.sessionId);
        return arg;
      },
      {
        onSuccess: function* () {
          yield put(fetchStaffSessions.request());
        },
      },
    ),
  );

  yield takeLatest(
    revokeAllStaffSessions.request.type,
    apiSaga(revokeAllStaffSessions, sessionsApi.revokeAllStaffSessions, {
      // Oturum bu istekle bitti: yenileme denemesi anlamsız, depo sıfırlanır.
      retryOnUnauthorized: false,
      onSuccess: function* () {
        yield put(signOut.success());
      },
    }),
  );
}
